/*
feature name: <kebab-case> --> analytics table

const flagConfig = {
	'feature-1-name': { probability: 0.5 }, <-- percentage of probability (from 0 to 1)
	'feature-2-name': { probability: 0.5, deps: ['feature-1-name'] }, <-- dependencies
}

usage:
	this.$isFlag('feature-1-name')
*/

import Cookies from 'js-cookie'

// Original full config
const allFlags = {
	'anonymous-holdout-group': { probability: 0 }, // leaving this here for potential re-use in the future
	'example-flag': { probability: 0.5 },
}

// Step 1: Independently evaluate 'anonymous-holdout-group'
const holdoutFlagKey = 'anonymous-holdout-group'
const holdoutFlagProbability = allFlags[holdoutFlagKey].probability
const holdoutFlagState = Math.random() <= holdoutFlagProbability

// Respect any cookie override
const cookieOverride = Cookies.get(holdoutFlagKey)
const finalHoldoutFlagValue = cookieOverride !== undefined ? cookieOverride === 'true' : holdoutFlagState

Cookies.set(holdoutFlagKey, finalHoldoutFlagValue)

// Step 2: Conditionally construct the real flagConfig
const flagConfig = {}

if (finalHoldoutFlagValue) {
	// Only include holdout flag
	flagConfig[holdoutFlagKey] = {
		...allFlags[holdoutFlagKey],
		state: finalHoldoutFlagValue,
	}
} else {
	// Include all other flags including holdout
	for (const key of Object.keys(allFlags)) {
		flagConfig[key] = {
			...allFlags[key],
			state: Math.random() <= allFlags[key].probability,
		}
	}
}

// ---- Everything below remains mostly unchanged ---- //

const checkFlag = name => {
	const flagData = flagConfig[name]
	const deps = flagData?.deps || []

	if (Cookies.get(name)) {
		return Cookies.get(name) === 'true'
	}

	// Turn off flag if it doesn't have dependencies
	for (let i = 0; i < deps.length; i++) {
		if (flagConfig[deps[i]] === undefined) {
			console.error('Unknown flag dependency', deps[i])
			return false
		}
		if (flagConfig[deps[i]].state === false) {
			return false
		}
	}

	if (!flagData) {
		console.error('Unknown feature flag, ', name)
		return false
	}
	return flagData.state
}

const computedFlags = {}
const computedFlagData = {}

for (const key of Object.keys(flagConfig)) {
	const value = checkFlag(key)
	computedFlags[key] = value
	computedFlagData[key] = {
		experiment_variant: value ? 1 : 0,
	}
	Cookies.set(key, value)
}

// eslint-disable-next-line no-underscore-dangle
const isFlag_ = name => {
	if (computedFlags[name] === undefined) {
		console.error('Feature flag is not defined: ', name)
		return false
	}
	return computedFlags[name]
}

export const getFlags = () => computedFlagData
export const isFlag = isFlag_

export default isFlag
